export const containerStyle = {
    padding: '16px 16px',
    borderRadius: '8px',
};
